import { render } from "./ScheduleFormStepFinalize.vue?vue&type=template&id=4edc4fc6"
import script from "./ScheduleFormStepFinalize.vue?vue&type=script&lang=ts"
export * from "./ScheduleFormStepFinalize.vue?vue&type=script&lang=ts"
script.render = render

export default script